import MeaDetailField from "../../../../components/MeaDetailField";
import MeaDetailCard from "../../../../components/MeaDetailCard";
import MeaLink from "../../../../components/MeaLink";

const ClasseDetailComponent = ({ classe }) => {
  return (
    <>
      <MeaDetailCard>
        <MeaDetailField field="Nom de la classe" value={classe?.name} />
        <MeaDetailField
          field="Niveau"
          value={
            <MeaLink
              to={
                "/school/" +
                classe?.school_id +
                "/admin/trainings/" +
                classe?.training_id +
                "/levels/" +
                classe?.level?.id
              }
            >
              {classe?.level?.name}
            </MeaLink>
          }
        />
        <MeaDetailField
          field="Capacité"
          value={classe?.max_capacity || "-"}
        />
        <MeaDetailField
          field="Référent(e)"
          value={
            classe?.referent
              ? (classe.referent.name
                ? classe.referent.name
                : `${classe.referent.lastname?.toUpperCase() || ""} ${classe.referent.firstname || ""}`.trim())
              : "-"
          }
        />
        <MeaDetailField
          field="Présentation"
          value={classe?.presentation || "-"}
        />
      </MeaDetailCard>
    </>
  );
};

export default ClasseDetailComponent;
